<template>
  <v-card
    :min-height="minh"
    :outlined="isoutlined"
    :tile="istile"
    :dark="isdark"
    :color="color">
    <slot name="header">
      <v-sheet class="pl-4 d-flex justify-start align-center" color="light-blue darken-3 white--text" height="40">
        <v-icon color="white">mdi-card-account-phone</v-icon>
        <div class="divider"></div>
        <span v-if="$store.state.lang == 'cn'"  class="text-button">联系我们</span>
        <span v-else  class="text-button">CantactUs</span>
      </v-sheet>
    </slot>
    <slot name="img"></slot>
    <v-overlay opacity="0.2" absolute :value="loading">
      <v-progress-circular indeterminate color="orange" width="5" size="50"></v-progress-circular>
    </v-overlay>
    <div>
      <div class="pa-2" v-if="content_loaded">
        <div
          class="text-subtitle-2"
          v-for="i,index in contact[$store.state.lang+'_content'].split('|')"
          :key="index">
          {{i}}
        </div>
      </div>
      <div class="d-flex justify-end align-center">
        <div class="text-caption" v-if="$store.state.lang == 'cn'">了<br>解<br>更<br>多</div>
        <div class="ma-2">
          <v-img
            contain
            max-width="90"
            src="http://47.94.10.11/static/files/coder1.png">
          </v-img>
        </div>
      </div>
    </div>

  </v-card>
</template>

<script>
export default{
  name:'contactbar',
  data(){
    return{
      contactbar_io_api:'contactbar/io/',
      contact:{},
      content_loaded:false,
      loading:false,
    }
  },
  props:{
    color:{
      type:String,
      default:'grey lighten-5',
    },
    minh:{
      type:Number,
      default:100,
    },
    isdark:{
      type:Boolean,
      default:false,
    },
    istile:{
      type:Boolean,
      default:false,
    },
    isoutlined:{
      type:Boolean,
      default:false,
    },
  },
  computed:{

  },
  methods:{
    fetch(){
      this.loading = true;
      let postdata = {};
      this.$axios.post(this.$store.state.baseurl + this.contactbar_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.contact = response.data.data;
                this.content_loaded = true;
                this.loading = false;
              }
            }
          )
          .catch(function (e){})
    },
  },
  mounted(){
    this.fetch();
  },
}
</script>

<style scoped>
.divider{
  height:40%;
  width:2px;
  background:#fff;
  margin:0 8px;
}
</style>